module.exports = __webpack_public_path__ + "static/media/download_app_store-pt.d8881539.png";